/**
 * SistemaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Sistema} from '@/model/resource/Sistema'

/* TODO: review generated class */
@HttpExclude()
export class SistemaCollection extends PageCollection<Sistema> {
  constructor() {
    super(Sistema)
  }

  queryAsPage() {
    return this.listSistema()
  }

  async listSistema() {
    return await Request.get(`/admin/sistema`, {params: this.params})
      .name('listSistema')
      .as(this)
      .getResponse()
  }

  async listCsvSistema() {
    return await Request.get(`/admin/sistema/csv`, {params: this.params})
      .name('listCsvSistema')
      .as(this)
      .getResponse()
  }
}
